<template>
  <div class="summary-wrapper" permission="activity">
    <div
      class="d-flex justify-center"
      :class="{ 'flex-column text-center': isMobile }"
    >
      <h2>Activity</h2>
    </div>
    <div class="dashboard__date">
      <DatePicker
        label=""
        @updatedDate="filterDates"
        isDark
        isRange
        class="date-picker-wrapper--no-label"
        data-test="datePicker"
        :class="{ 'pl-3': !isMobile }"
      />
    </div>
    <div v-if="isLoading">
      <v-skeleton-loader
        v-for="i in 5"
        :key="i"
        width="50%"
        class="mt-5"
        type="list-item-avatar-two-line"
      />
    </div>
    <SummaryFilters
      @onClearFilters="clearFilters"
      :isLoading="isLoading"
      :availableFilters="availableFilters"
      :filterLabels="filterLabels"
      :outerSelectedFilters="filters"
      @filter="updateFilters"
    />
    <div class="dashboard__client" v-if="clientSummary && !isLoading">
      <div class="dashboard__client--summary">
        <DashboardCard
          data-test="summary-item"
          v-for="(summary, index) in filteredSummary"
          :key="index"
          :summary="summary"
          :organisationId="clientSummary.organisationId"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardCard from "@/components/dashboard/DashboardCard";
import { filter } from "lodash";
import DatePicker from "@/components/common/DatePicker";
import { FETCH_SUMMARY } from "@/store/modules/dashboard/action-types";
import { DASHBOARD_NAMESPACE } from "@/store/modules/dashboard";
import { createNamespacedHelpers } from "vuex";
import SummaryFilters from "@/components/dashboard/SummaryFilters";

const { mapState, mapActions } = createNamespacedHelpers(DASHBOARD_NAMESPACE);

export default {
  props: {
    permissions: Object
  },
  components: {
    DashboardCard,
    DatePicker,
    SummaryFilters
  },
  created() {
    this.getClients();
  },
  data() {
    return {
      filters: {},
      dateFilters: {},
      isLoading: false,
      availableFilters: {},
      filterLabels: {}
    };
  },
  computed: {
    ...mapState({
      clientSummary: state => state.clientSummary
    }),
    filteredSummary() {
      return filter(this.clientSummary.summaries, summary => {
        switch (summary.name) {
          case "Bookings": {
            if (this.permissions["dashboard.bookings-total"]) return summary;
            break;
          }
          case "Applications": {
            if (this.permissions["dashboard.applications-total"])
              return summary;
            break;
          }
          default:
            return summary;
        }
      });
    }
  },
  methods: {
    ...mapActions({
      fetchSummaries: FETCH_SUMMARY
    }),
    async getClients() {
      this.isLoading = true;
      const data = await this.fetchSummaries({
        filter: {
          ...this.filters,
          ...this.dateFilters
        }
      });
      if (data && data.meta) {
        this.adjustPageDetails(data.meta);
      }
      this.isLoading = false;
    },
    adjustPageDetails({ filters, labels }) {
      this.availableFilters = filters;
      this.filterLabels = labels;
    },
    async filterDates(dates) {
      this.dateFilters.period_start = dates[0];
      this.dateFilters.period_end = dates[1];
      this.getClients();
    },
    updateFilters(filters) {
      this.filters = filters;
      this.getClients();
    },
    clearFilters() {
      this.filters = {};
      this.getClients();
    }
  }
};
</script>

<style lang="scss">
.summary-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 50px;
}
</style>
